export const normalizeAngle = (angle) =>
  (angle < 0 ? angle + 2 * Math.PI : angle) % (2 * Math.PI);
